<template>
  <div class="filter-set range-filter price-range">
    <button
      class="filter-name"
      @click.stop="$emit('toggle')"
      :class="getBoxClass()"
      :aria-expanded="expanderVisible ? 'true' : 'false'"
      :aria-controls="id + '-slider-panel'"
      id="price-range-toggle"
      type="button"
    >
      <span class="filter-name__label">Myyntihinta</span>
      <i class="toggle-expander icon-chevron-down"></i>
    </button>
    <expander :expanded="expanderVisible">
      <div
        class="slider-input price-range-input"
        v-if="slider"
        :id="id + '-slider-panel'"
        role="region"
        :aria-labelledby="'price-range-toggle'"
      >
        <form-slider
          :id="id"
          ref="slider"
          :conf="slider"
          @changed="handleSliderChange($event)"
          aria-label="Valitse myyntihinnan vaihteluväli euroina"
        ></form-slider>
      </div>
    </expander>
  </div>
</template>

<script>
import Expander from '../expander/expander.vue';
import FormSlider from '../form-slider/form-slider.vue';
import config from '@/config';
import searchUtils from '@/app/utils/search-utils';
import logger from '@/app/logger';

export default {
  name: 'price-range',
  data: () => ({
    slider: false,
    id: '',
  }),
  props: {
    expanderVisible: {
      type: Boolean,
      default: undefined, // By default, the expander is visible but without any complex close/open css logic
    },
    currentMin: {
      type: Number,
      required: false,
    },
    currentMax: {
      type: Number,
      required: false,
    },
  },
  computed: {
    sliderMin() {
      return this.currentMin || config.FILTER_LIMITS.PRICE_MIN;
    },
    sliderMax() {
      return this.currentMax || config.FILTER_LIMITS.PRICE_MAX;
    },
  },
  watch: {
    sliderMin: 'refreshUI',
    sliderMax: 'refreshUI',
  },
  methods: {
    initSlider(id) {
      this.id = id;

      this.slider = {
        unit: '€',
        start: [this.sliderMin, this.sliderMax],
        step: 1000,
        margin: 1000,
        range: {
          min: config.FILTER_LIMITS.PRICE_MIN,
          '50%': [150000, 10000],
          '80%': [800000, 10000],
          max: config.FILTER_LIMITS.PRICE_MAX,
        },
      };
    },
    refreshUI() {
      this.slider.start = [this.sliderMin, this.sliderMax];
    },
    getBoxClass() {
      return this.currentMin || this.currentMax ? 'in-use' : '';
    },
    handleSliderChange(values) {
      if (values && Array.isArray(values) && values.length === 2) {
        searchUtils.addFilterToUrl(this.$router, this.$route, {
          priceMin: values[0],
          priceMax: values[1],
        });
      } else {
        logger.info('Invalid values for price range slider: ', { values });
      }
    },
  },
  mounted() {
    this.initSlider(this.$.uid.toString());
  },
  components: {
    Expander,
    FormSlider,
  },
};
</script>
